<div class="app-root">
  <app-header></app-header>
  <app-start-proco></app-start-proco>
  <div class="router-outlet">
    <router-outlet></router-outlet>
  </div>
  <app-scroll-top></app-scroll-top>
  <ngx-spinner bdColor="rgba(51,51,51,0.5)" size="medium" color="#ffd000" type="ball-spin-clockwise"> </ngx-spinner>
  <app-footer></app-footer>
</div>